import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useIsMobile } from '@stores/AppCommonData';
import { sectionsIds } from '../sections';
import { Spacings, mobile } from '../../../../styleConstants';
import SectionContainer from '../SectionContainer';
import Speaker from './Speaker/Speaker';

// const celebrities = [
//   {
//     name: 'Shri Pranab Mukherjee',
//     username: 'PranabMukharjee',
//     subText: 'Former President of India, Bharat Ratna',
//     bio:
//       'Bharat Ratna Shri Pranab Mukherjee is the former President of India. In his career, he has occupied several ministerial portfolios in the Government of India.',
//     textColor: '#B27A64',
//     bgColor: '#FBD1BA',
//     svgColor: '#EDBFA9'
//   },
//   {
//     textColor: '#92A365',
//     bgColor: '#E0E9D0',
//     svgColor: '#D0DBBA',
//     name: 'Kapil Dev',
//     bio:
//       'One of the greatest all-rounders Kapil Dev is also one of the greatest captains in the history of cricket. He is a Padma Shri and Padma Bhushan awardee.',
//     subText: 'Former India Captain',
//     username: 'KapilDev99'
//   },
//   {
//     textColor: '#E06A80',
//     bgColor: '#FFE4DF',
//     svgColor: '#F2C3C2',
//     name: 'Dr. Shashi Tharoor',
//     bio:
//       'A celebrated diplomat, Shashi Tharoor is a former Under-Secretary General of the United Nations. ',
//     subText: 'Member of Parliament',
//     username: 'DrShashi'
//   },
//   {
//     textColor: '#787988',
//     bgColor: '#D8D9E3',
//     svgColor: '#C5C6D1',
//     name: 'Jairam Ramesh',
//     bio:
//       'Shri Jairam Ramesh is a Rajya Sabha MP. He is a celebrated economist and policy expert, who has held several ministerial portfolios in his career.',
//     subText: 'Economist, MP',
//     avatar: 'https://quark.uacdn.net/summit/JairamRamesh.png',
//     username: 'JairamRamesh1'
//   },
//   {
//     textColor: '#E06A80',
//     bgColor: '#F6DDD6',
//     svgColor: '#F2C6C5',
//     name: 'Dr. Kiran Bedi',
//     bio:
//       'Kiran Bedi is the first female Indian Police Officer, who has also held the office of Director General, Bureau of Police Research and Development.',
//     subText: 'IPS (Retd.) Hon’ble Lt. Governor, Puducherry',
//     username: 'kiranbedi'
//   },
//   {
//     name: 'Rajkummar Rao',
//     username: 'RajKumarRao1',
//     subText: 'Bollywood Actor',
//     bio:
//       'Rajkummar Rao, one of the most versatile actors, is known for his unique roles that have garnered both critical acclaim and box office success.',
//     textColor: '#7A7B86',
//     bgColor: '#CDCFDA',
//     svgColor: '#BCBFC9'
//   }
// ];

// const educators = [
//   {
//     textColor: '#93B112',
//     bgColor: '#F0F7D2',
//     svgColor: '#F0F7D2',
//     name: 'DP Agrawal',
//     bio:
//       'D. P Agrawal is the ex Chairman of the Union Public Service Commission. In his career, Prof. Agrawal has spearheaded major reforms in various exams.',
//     subText: 'Ex. UPSC Chairman',
//     avatar: 'https://quark.uacdn.net/summit/DPagrwal.png',
//     username: 'devupsc'
//   },
//   {
//     textColor: '#815A43',
//     bgColor: '#EAD8CC',
//     svgColor: '#EAD8CD',
//     name: 'Armstrong Pame',
//     bio:
//       'India’s Most Eminent IAS Officer Award ’2015 awardee, Armstrong Pame is famous for raising 40 lakhs to build “People’s Road”.',
//     subText: 'IAS, Deputy Commissioner, Tamenglong District',
//     username: 'armstrong.pame'
//   },
//   {
//     textColor: '#CA6C52',
//     bgColor: '#FFE8BB',
//     svgColor: '#FFE8BB',
//     name: 'Prashanth Nair',
//     bio:
//       'Prasanth Nair is a civil servant who secured AIR 4 in UPSC CSE. He is known for initiating ‘Operation Sulaimani’ to eradicate hunger in Kozhikode.',
//     subText: 'IAS, MD - KSINC, MD - KIIDC',
//     username: 'PrasanthNair1'
//   },
//   {
//     textColor: '#AA4F49',
//     bgColor: '#FFDDCD',
//     svgColor: '#FFDDCD',
//     name: 'Roopa DM',
//     bio:
//       'IPS, officer D Roopa is the Inspector General of Police - Railways of Bengaluru. She got All-India rank 43 in UPSC 2000 and opted for IPS.',
//     subText: 'IPS Inspector General of Police - Railways, Bengaluru',
//     username: 'ipsroopa'
//   },

//   {
//     textColor: '#E0605D',
//     bgColor: '#EDC8C1',
//     svgColor: '#EDC8C1',
//     name: 'Sanjukta Parashar',
//     bio:
//       'Sanjukta Parashar is an IPS officer known for her proactive policing against pressing issues including terrorism and raising the Veerangana Squad.',
//     subText: 'IPS, Superintendent of Police, NIA',
//     username: 'sanjukta.ops'
//   },

//   {
//     textColor: '#733D3C',
//     bgColor: '#E1A9A3',
//     svgColor: '#E1A9A3',
//     name: 'Vipul Pandey',
//     bio:
//       'Instrumental in reducing plastic use, IFS (Forest) officer Vipul Pandey is known for his eco-friendly initiatives to shape a greener India.',
//     subText: 'IFS (Forest) Officer',
//     username: 'VipulPandey2020'
//   },

//   {
//     textColor: '#405A6C',
//     bgColor: '#B5C3CD',
//     svgColor: '#B5C3CD',
//     name: 'Chhavi Rajawat',
//     bio:
//       "Chhavi Rajawat is India's first and youngest sarpanch. She holds a MBA degree and has transformed 'Soda' village completely.",
//     subText: "India's first and youngest village sarpanch with an MBA degree",
//     username: 'chhavi.rajawat'
//   },

//   {
//     textColor: '#A36752',
//     bgColor: '#FFC9AE',
//     svgColor: '#FFC9AE',
//     name: 'Rujuta Diwekar',
//     bio:
//       'Rujuta Diwekar is a leading public health advocate who is better known as a nutrition expert. She has authored many bestsellers about modern nutrition.',
//     subText: 'Dietician',
//     avatar: 'https://quark.uacdn.net/summit/RujutaDiwekar98.png',
//     username: 'RujutaDiwekar'
//   },

//   // {
//   //   textColor: '#787988',
//   //   bgColor: '#D8D9E3',
//   //   svgColor: '#D8D9E3',
//   //   name: 'Gaurav Munjal',
//   //   bio: 'Gaurav Munjal is the CEO and co-founder of Unacademy. ',
//   //   subText: 'Co-Founder and CEO at Unacademy',
//   //   avatar: 'https://quark.uacdn.net/summit/gaurav.png',
//   //   username: 'GauravMunjal'
//   // },

//   // {
//   //   textColor: '#FF8C4E',
//   //   bgColor: '#FFBD9A',
//   //   svgColor: '#FFBD9A',
//   //   name: 'Ankita Tandon',
//   //   bio:
//   //     'Ankita Tandon is the VP of Business at Unacademy and is responsible for developing the pedagogy.  ',
//   //   subText: 'VP, Unacademy',
//   //   avatar: 'https://quark.uacdn.net/summit/ankitattandon.png',
//   //   username: 'AnkitaTandon'
//   // },
//   {
//     textColor: '#7C6D4F',
//     bgColor: '#BEB49E',
//     svgColor: '#BEB49E',
//     name: 'Tina Dabi',
//     bio:
//       'Tina Dabi is an IAS officer and secured AIR 1 in UPSC CSE, 2015. A DU alumnus, she is also a university topper.',
//     subText: 'AIR 1, 2015',
//     username: 'TinaDabi1'
//   },
//   {
//     textColor: '#444752',
//     bgColor: '#D4D4D4',
//     svgColor: '#D4D4D4',
//     name: 'Athar Aamir Khan',
//     bio:
//       'Athar Aamir Khan is an IITian turned IAS officer. He secured AIR 2 in the civil services exam in 2015 at the young age of 23, in his second attempt.',
//     subText: 'AIR 2, 2015',
//     username: 'a.aamir055'
//   },
//   {
//     textColor: '#1E314C',
//     bgColor: '#D4E6FF',
//     svgColor: '#D4E6FF',
//     name: 'Junaid Ahmed',
//     bio:
//       'Junaid Ahmed is an IAS officer and secured AIR 3 in UPSC CSE, 2018. He is famous for pioneering the internet for his success and highlighting the importance of being resourceful.',
//     subText: 'AIR 3, 2018',
//     username: 'junaidahmedirs'
//   },
//   {
//     textColor: '#546933',
//     bgColor: '#E9D494',
//     svgColor: '#E9D494',
//     name: 'Saumya Pandey',
//     bio:
//       'Saumya Pandey is an IAS officer, known for securing AIR 4 in UPSC CSE in her very first attempt. She is also a university gold medalist in B.Tech.',
//     subText: 'AIR 4, 2016',
//     username: 'saumyapandey99'
//   },
//   {
//     textColor: '#9D6892',
//     bgColor: '#F0DDE7',
//     svgColor: '#F0DDE7',
//     name: 'Anand Vardhan',
//     bio:
//       'Anand Vardhan is an IAS officer and secured AIR 7 in UPSC CSE, 2016 in his fourth attempt. He is also an alumnus of the reputed Delhi Technological University. ',
//     subText: 'AIR 7, 2016',
//     username: 'anandvardhan1'
//   },

//   {
//     textColor: '#816B69',
//     bgColor: '#ECD5D1',
//     svgColor: '#ECD5D1',
//     name: 'Nandini Maharaj',
//     bio:
//       'Nandini Maharaj secured AIR 42 in UPSC CSE, 2018. She holds a masters degree in Applied Human Rights and is an alumnus of Lady Shri Ram College.',
//     subText: 'AIR 42, 2018',
//     username: 'nandinimaharaj'
//   },
//   {
//     textColor: '#375BB4',
//     bgColor: '#B4C1E1',
//     svgColor: '#B4C1E1',
//     name: 'Nishant Jain',
//     bio:
//       'Nishant Jain cracked UPSC CSE in 2014 with an AIR of 13. He is known for his inspirational journey and his story has motivated many aspirants to give their very best while preparing for UPSC CSE.',
//     subText: 'AIR 13, 2014',
//     username: 'nishant.jain111@gmail.com'
//   },
//   {
//     textColor: '#9E7D24',
//     bgColor: '#EEE6BB',
//     svgColor: '#EEE6BB',
//     name: 'Noorul Hassan',
//     bio:
//       'Noorul Hassan cracked UPSC CSE in 2015. He is one of the youngest people to do so, at an age of 22. ',
//     subText: 'IPS Officer, AIR 625, 2015',
//     username: 'noorulhasan123'
//   },
//   // {
//   //   textColor: '#733D3C',
//   //   bgColor: '#E1A9A3',
//   //   svgColor: '#E1A9A3',
//   //   name: 'Abhishek Srivastava',
//   //   bio:
//   //     'Abhishek Srivastava is the Associate Director at Unacademy and is the head of UPSC CSE category.',
//   //   subText: 'Associate Director, Unacademy',
//   //   username: 'abhishek6077'
//   // },
//   {
//     textColor: '#787988',
//     bgColor: '#D8D9E3',
//     svgColor: '#D8D9E3',
//     name: 'Rakesh Verma',
//     bio: 'Bio - B.Tech, MA Economics, MBA; Ex. IAS Officer',
//     subText: 'Ex- IAS Officer',
//     username: 'vrakeshv281'
//   },
//   {
//     textColor: '#EB6015',
//     bgColor: '#FFD0B2',
//     svgColor: '#FFD0B2',
//     name: 'Mrunal Patel',
//     bio: 'Top Plus Educator with 13M watch minutes',
//     subText: 'Unacademy Educator',
//     username: 'mrunal.org'
//   },
//   {
//     textColor: '#444752',
//     bgColor: '#D4D4D4',
//     svgColor: '#D4D4D4',
//     name: 'Atish Mathur',
//     bio:
//       'Lawyer, Faculty at Vajiram & Ravi, Expert in Governance, Polity, Indian Government & Politics',
//     subText: 'Unacademy Educator',
//     username: 'atishmathur2015'
//   },
//   {
//     textColor: '#1E314C',
//     bgColor: '#D4E6FF',
//     svgColor: '#D4E6FF',
//     name: 'Sidharth Arora',
//     bio: 'Top Plus Educator, M.B.B.S. and L.L.B., Advocate in Supreme Court',
//     subText: 'Unacademy Educator',
//     username: 'sidhartharoraofficial'
//   },
//   {
//     textColor: '#B1905F',
//     bgColor: '#DAC5A7',
//     svgColor: '#DAC5A7',
//     name: 'Awdhesh Singh',
//     bio:
//       'Ex-IIT, Former IRS Officer, CSE-1989 Rank 272, Expert in Ethics & Essay Writing',
//     subText: 'Ex-IRS Officer',
//     username: 'aksinghirs'
//   },
//   {
//     textColor: '#466B67',
//     bgColor: '#C8F0EB',
//     svgColor: '#C8F0EB',
//     name: 'Deepanshu Singh',
//     bio:
//       'Top Plus Educator with 4+ years of experience UPSC CSE Reserve List 2015; Expert in Polity & Geography',
//     subText: 'Unacademy Educator',
//     username: 'deepanshu.n.singh'
//   }
// ];

const MainSpeakersWrapper = styled.section`
  display: grid;
  grid-template-columns: repeat(3, 300px);
  grid-column-gap: ${Spacings.SPACING_16B};
  grid-row-gap: ${Spacings.SPACING_20B};
  justify-content: center;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    grid-template-columns: 1fr;
    grid-row-gap: ${Spacings.SPACING_10B};
  }
`;

const SubSpeakersWrapper = styled.div`
  margin-top: ${Spacings.SPACING_20B};
  display: grid;
  grid-template-columns: repeat(4, 200px);
  grid-column-gap: ${Spacings.SPACING_16B};
  grid-row-gap: 58px;
  justify-content: center;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    grid-template-columns: repeat(2, 150px);
    grid-row-gap: ${Spacings.SPACING_10B};
    grid-column-gap: ${Spacings.SPACING_5B};
  }
`;

const SummitEvents = ({ headerRefs }) => {
  const isMobileDevice = useIsMobile();
  const staticTexts = useSelector(({ summit }) => summit.staticTexts);
  const speakers = useSelector(({ summit }) => summit.speakers || []);
  const celebrities = speakers.filter((speaker) => speaker.isCeleb);
  const educators = speakers.filter((speaker) => !speaker.isCeleb);
  return (
    <SectionContainer
      title="Speakers"
      color="#E06A80"
      sectionId={sectionsIds.speakers}
      headerRefs={headerRefs}
      contentMarginTop={isMobileDevice ? Spacings.SPACING_10B : '120px'}
      quote={staticTexts.speakersHeader || ''}
      description={staticTexts.speakersDesc || ''}
    >
      <MainSpeakersWrapper>
        {celebrities.map((author) => (
          <Speaker key={author.username} author={author} />
        ))}
      </MainSpeakersWrapper>
      <SubSpeakersWrapper>
        {educators.map((author) => (
          <Speaker key={author.username} author={author} type="small" />
        ))}
      </SubSpeakersWrapper>
    </SectionContainer>
  );
};

SummitEvents.propTypes = {
  headerRefs: PropTypes.objectOf(PropTypes.object).isRequired
};

export default SummitEvents;
